import React from "react";
import { Droppable } from "react-beautiful-dnd";

import IconHide from "./IconHide";
import IconLock from "./IconLock";
import UnScheduledSteps from "./UnScheduledSteps";
import { getListStyle } from "./Utils";

import { useSelector } from "react-redux";
import { getTranslation } from "../../utils/helper";

const UnScheduled = ({
  steps,
  stepsHovered,
  setStepsHovered,
  onClickStep,
  onHoverStep,
  handleCloseStepPopup,
  isDragging,
  driverIdsHide,
  onClickHide,
  actionDnd,
  isLive,
  selectedMultipleSteps,
  setAllInclusiveMultipleSteps,
  multipleStepState,
}) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  const isHide = driverIdsHide.includes("unassigned");

  return (
    <div className="tr">
      <div className="td">
        <div className="driver-name">
          <IconLock hidden={true} />
          <IconHide isHide={isHide} onClickHide={() => onClickHide("unassigned")} />
          {getTranslation(setting, "Route Plans", "Unscheduled")} ({steps.length})
        </div>
      </div>
      <div className="td" style={{ width: "100%" }}>
        <Droppable
          key="unscheduled"
          droppableId="unscheduled"
          direction="horizontal"
          isDropDisabled={actionDnd === "optimize" || isLive}>
          {(provided, snapshot) => (
            <div
              className={`scrollCustom unscheduled-steps ${isDragging && "isDragging"} ${actionDnd}`}
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{
                maxWidth: "calc(100vw - 720px)",
                display: "flex",
                alignItems: "center",
                userSelect: "none",
                height: "40px",
                minWidth: `${steps.length * 24 + 10}px`,
                overflow: "auto",
                zIndex: 999,
                ...getListStyle(isDragging, snapshot.isDraggingOver, actionDnd === "optimize"),
              }}>
              <UnScheduledSteps
                steps={steps.reduce((array, item) => array.concat(item), [])}
                stepsHovered={stepsHovered}
                setStepsHovered={setStepsHovered}
                onClickStep={onClickStep}
                onHoverStep={onHoverStep}
                handleCloseStepPopup={handleCloseStepPopup}
                setting={setting}
                selectedMultipleSteps={selectedMultipleSteps}
                setAllInclusiveMultipleSteps={setAllInclusiveMultipleSteps}
                multipleStepState={multipleStepState}
              />
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    </div>
  );
};

export default UnScheduled;
